import { gql } from '../../../generated';

const SalesPerCurrencyChart = gql(/* GraphQL */ `
  query SalesPerCurrencyChart($gate_group_id_1: String!, $gate_group_id_2: String!, $period: DashboardV2PeriodType!) {
    dashboardWidgetsSalesPerCurrencyChartV2(
      gate_group_id_1: $gate_group_id_1
      gate_group_id_2: $gate_group_id_2
      period: $period
    ) {
      total
      gate_group_1 {
        gate_group_id
        gate_group_name
        value
        percent
      }
      gate_group_2 {
        gate_group_id
        gate_group_name
        value
        percent
      }
    }
  }
`);

export default SalesPerCurrencyChart;
